export const GET_INSTITUTE_EXAMS = "GET_INSTITUTE_EXAMS";
export const GET_INSTITUTE_USERS = "GET_INSTITUTE_USERS";
export const GET_INSTITUTE_QUESTIONS = "GET_INSTITUTE_QUESTIONS";
export const GET_INSTITUTE_LISTENING = "GET_INSTITUTE_LISTENING";
export const GET_INSTITUTE_RESULTS = "GET_INSTITUTE_RESULTS";
